import { useEffect, useState } from "react"
import {  maxSelectOptionLength } from "../../../../../utils/constants"

export const useItem = ()=>{
const [value, setValue] = useState<string>('')
const[disabled, setDisabled] = useState<boolean>(false)

useEffect(()=>{
    setDisabled(value.length === 0 || value.length > maxSelectOptionLength)
}, [value.length])

    return {value, setValue, disabled}
}